export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-item/index.js